import { getPublicTimeline } from '../../../api/timelines/timelines';
import { timelineStoreCreator } from './timeline-store-creator';

export const createFederatedTimelineStore = timelineStoreCreator({
  getTimeline: (account, args) => getPublicTimeline(account, args),
  timelineStream: 'public',
});
